<app-navbar title="Dodawanie wydarzenia">
	<button class="btn btn-primary me-2" (click)="submit()">Zapisz</button>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<form class="container my-4" (submit)="submit()">
	<div class="form-floating mb-3">
		<input
			class="form-control"
			id="name"
			name="name"
			[(ngModel)]="event.name"
			[ngClass]="{ error: this.errors.name }"
		/>
		<label for="name">Miejsce postoju</label>
	</div>
	<div class="form-floating mb-3">
		<input
			type="text"
			class="form-control"
			id="text_program"
			name="text_program"
			[(ngModel)]="event.text_program"
			[ngClass]="{ error: this.errors.text_program }"
		/>
		<label for="text_program">Miejsce dokumentów i kluczyków</label>
	</div>
	<div class="form-floating mb-3">
		<input
			type="datetime-local"
			class="form-control"
			name="date_from"
			id="date_from"
			[appUtcModel]="event.date_from"
			(appUtcModelChange)="
				event.date_from = $event; calculateDateTo(); calculateDatePrepare(); calculateDateDeadline()
			"
			[ngClass]="{ error: this.errors.date_from }"
		/>
		<label for="date_from">Data rozpoczęcia</label>
	</div>
	<div class="form-floating mb-3">
		<input
			type="datetime-local"
			class="form-control"
			name="date_to"
			id="date_to"
			[appUtcModel]="event.date_to"
			(appUtcModelChange)="event.date_to = $event; calculateDateDeadline()"
			[ngClass]="{ error: this.errors.date_to }"
		/>
		<label for="date_to">Data zakończenia</label>
	</div>
	<div class="mb-3">
		<app-tourism-events-vehicle-add
			[min]="event.date_from"
			[max]="event.date_to"
			[vehicles]="vehicles"
			[editable]="lockEdit"
			[alreadyAddedVehicles]="event.vehicles"
			(emitVehiclesArray)="setVehicles($event)"
		></app-tourism-events-vehicle-add>
	</div>
	<div class="mb-3">
		<label class="form-label">Klient</label>
		<app-tourism-events-organization
			[client]="event.client"
			(clientData)="sendData($event)"
		></app-tourism-events-organization>
	</div>
	<div class="mb-3">
		<label class="form-label" for="owner">Opiekun</label>
		<ng-select
			id="owner"
			name="owner"
			[(ngModel)]="event.owner"
			placeholder="(wybierz)"
			bindLabel="name"
			[multiple]="true"
			[ngClass]="{ error: this.errors.owner }"
			required
		>
			<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
		</ng-select>
	</div>
	<div class="form-floating mb-3">
		<select class="form-select" id="status" name="status" [(ngModel)]="event.status">
			<option value="{{ item.id }}" *ngFor="let item of statuses">
				{{ item.name }}
			</option>
		</select>
		<label for="status">Status</label>
	</div>
</form>
